import { IconCheck } from '@holbonkit/icons'
import { Box, Text } from '@holbonkit/ui'
import clsx from 'clsx'

import type { SbpBank } from '@/shared/api'
import { BankIcon } from '@/shared/ui'

import styles from './list-item.module.scss'

type TListItemProps = {
    bank: SbpBank
    onClick: () => void
    type: 'default' | 'selected' | 'used' | 'usedAndSelected'
}

export const ListItem = ({ bank, onClick, type }: TListItemProps) => {
    switch (type) {
        case 'usedAndSelected': {
            return (
                <Box className={clsx(styles['item--selected'], styles['item'])}>
                    <BankIcon name={bank.name} url={bank.icon_url} />
                    <Box className={styles['item--text']}>
                        <Text variant='body-m-16-medium'>{bank.name}</Text>
                        <Text variant='body-s-14-regular'>Вы уже добавили счёт этого банка</Text>
                    </Box>
                    <IconCheck color='var(--text-and-icon-accent)' size={24} />
                </Box>
            )
        }
        case 'used': {
            return (
                <Box className={styles['item']} onClick={onClick}>
                    <BankIcon name={bank.name} url={bank.icon_url} />
                    <Box className={styles['item--text']}>
                        <Text variant='body-m-16-medium'>{bank.name}</Text>
                        <Text variant='body-s-14-regular'>Вы уже добавили счёт этого банка</Text>
                    </Box>
                </Box>
            )
        }
        case 'selected': {
            return (
                <Box className={clsx(styles['item--selected'], styles['item'])}>
                    <BankIcon name={bank.name} url={bank.icon_url} />
                    <Box className={styles['item--text']}>
                        <Text variant='body-m-16-medium'>{bank.name}</Text>
                    </Box>

                    <IconCheck color='var(--text-and-icon-accent)' size={24} />
                </Box>
            )
        }
        default: {
            return (
                <Box className={styles['item']} onClick={onClick}>
                    <BankIcon name={bank.name} url={bank.icon_url} />
                    <Box className={styles['item--text']}>
                        <Text variant='body-m-16-medium'>{bank.name}</Text>
                    </Box>
                </Box>
            )
        }
    }
}
